import { render, staticRenderFns } from "./rutaIndex.vue?vue&type=template&id=4a28f815"
import script from "./rutaIndex.vue?vue&type=script&lang=js"
export * from "./rutaIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports